/**
 * Route for `fraud-reports-most-fraudulent-campaigns-publishers`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { FraudReportsMostFraudulentCampaignsPublishersPage } from "../features/fraud-reports-most-fraudulent-campaigns-publishers/FraudReportsMostFraudulentCampaignsPublishersPage";

export const fraudReportsMostFraudulentCampaignsPublishersRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/fraud-reports-most-fraudulent-campaigns-publishers",
	component: FraudReportsMostFraudulentCampaignsPublishersPage,
});

export default fraudReportsMostFraudulentCampaignsPublishersRoute;
